import React, { useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useNavigate, useLocation } from 'react-router-dom';

import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';

import FormProject from '../Form';

interface Customer {
  customerId: number;
  name: string;
}

interface SelectProps {
  value: number;
  label: string;
}

interface Project {
  name: string;
  customerId: number;
  customerName: string;
  type: SelectProps;
}

const CreateProject: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const location = useLocation();
  const state = location.state as Customer;
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (data: Project) => {
      try {
        formRef.current?.setErrors({});

        const selectValue =
          formRef.current?.getFieldRef('customerId').current.state.selectValue;

        const customerName = selectValue.length > 0 ? selectValue[0].label : '';

        const type =
          formRef.current?.getFieldRef('type').current?.state?.selectValue[0];

        const project = {
          ...data,
          customerName,
          type,
        };

        const schema = Yup.object().shape({
          customerId: Yup.number().required('Customer ID is required'),
          customerName: Yup.string().required('Customer Name is required'),
          name: Yup.string().required('Project name is required'),
        });

        await schema.validate(project, {
          abortEarly: false,
        });

        const response = await api.post('/projects', project);

        navigate(`/projects/${response.data.projectId}/dashboard`, {
          state: { project: response.data },
        });

        addToast({
          type: 'success',
          title: 'Success',
          description: 'The project was created successfully!',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Registration Error',
          description:
            'An error occurred while creating project, please try again.',
        });
      }
    },
    [addToast, navigate],
  );

  return (
    <>
      <h1>New Project</h1>

      <FormProject
        formRef={formRef}
        handleSubmit={handleSubmit}
        buttonText="Create"
        customerData={state}
      />
    </>
  );
};

export default CreateProject;
